import React, {useEffect, useState,useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import searchIcon from '../../assets/search-glass.png';
import PageBase from "../../components/PageBase";
import Datatable from "../../components/Datatable";
import Filters from "../../components/Filters";
import columns from './column.js';
import * as contactActions from "../../redux/Contact/actions";
import Toaster from "../../components/Toaster";
import ToggleButton from "../../components/ToggleButton";
import SelectCampaign from "../Mapping/SelectCampaign";
import Button from "../../components/Button";
import saveDiskIcon from "../../assets/save-disk.png";
import PopupWin from "../../components/PopupWin";
import PopupButton from "../../components/PopupButton";
import * as campaignActions from "../../redux/Campaign/actions";
import {isNullOrEmpty} from "../../utils/general";
import Icon from "react-web-vector-icons";
import * as ROUTES from "../../utils/routes";
import * as staticData from '../../redux/staticData/actions';
import usePersistentFilters from '../../hooks/usePersistentFilters';
import useColumnFilters from '../../hooks/useColumnFilters';
import { getDisplayFields, getDefaultFields } from '../../utils/fields/contacts.js';
import { createColumnConfigs } from '../../utils/fieldUtils.js';
import constants  from '../../utils/constants.js';
import ListManager from '../../components/ListManager';
import Pagination from "../../components/Pagination";

import './Contacts.scss';

const Contacts = props => {
	const limit = 15;
	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [selectedVendor, setSelectedVendor] = useState('aws');
	const [file, setFile] = useState(null);
	const [showPickCampaign, setShowPickCampaign] = useState(false);
	const [selectedCampaignId, setSelectedCampaignId] = useState('-1');
	const [dropdownData, setDropdownData] = useState(null);
	const [segment, setSegment] = useState(null);
	const [selectedContacts, setSelectedContacts] = useState([]);
	const [listColumns, setListColumns] = useState([]);
	const entityType = `${constants.DISPLAY_ENTITIES.CONTACTS}`;

	const params = useParams();
	let members = useSelector(state => state.contact)[selectedVendor === 'aws' ? 'awsContacts' : 'msContacts'];
	let total = useSelector(state => state.contact)[selectedVendor === 'aws' ? 'awsContactsTotal' : 'msContactsTotal'];
	const hiddenFileInput = React.useRef(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [filterResetKey, setFilterResetKey] = useState(0);
		const fieldsToUse = useMemo(() => {
		return createColumnConfigs(getDisplayFields(listColumns.length === 0,listColumns))
		}, [listColumns]);

	const {
		search,
		setSearch,
		selectedFilters,
		setSelectedFilters,
		clearFilters: clearPersistentFilters
	} = usePersistentFilters(`${selectedVendor}_contacts`, '', []);
	const [debouncedQuery, setDebouncedQuery] = useState(search);

	const {
		filters,
		sortBy,
		sortOrder,
		filteredData,
		handleFilterChange,
		resetWith,
		updateData,
		uniqueValuesByColumn,
		filterOrder
	} = useColumnFilters({
		data: members,
		columns:fieldsToUse,
		storageKey: `${selectedVendor}_contacts`,
		initialState: {}
	});

	const totalPages = Math.ceil(total / limit);

	const selectCampaignFooter = useMemo(() => (
		<>
			<PopupButton
				variant="secondary"
				onClick={() => setShowPickCampaign(false)}
			>
				Cancel
			</PopupButton>
			<PopupButton
				variant="primary"
				disabled={selectedCampaignId == null || selectedCampaignId === '-1'}
				onClick={() => {
					dispatch(campaignActions.addCampaignContact(selectedCampaignId, selectedContacts, (result) => {
						if(result.status === "ok") {
							Toaster.showSuccess("Added to campaign!");
						}else{
							Toaster.showError(result.message);
						}
						setSelectedCampaignId('-1');
						setShowPickCampaign(false);
						setSelectedContacts([]);
					}));
				}}
			>
				Select Campaign
			</PopupButton>
		</>
	), [selectedCampaignId, selectedContacts, dispatch]);

	useEffect(() => {
		const load = async () => {
			const offset = (page - 1) * limit;
			const withTotal = true
			const filters = debouncedQuery.value ? [debouncedQuery, ...selectedFilters] : [...selectedFilters];
			await dispatch(contactActions.loadContacts(selectedVendor, limit, offset, withTotal,filters));
			setLoading(false);
		};
		load();
    }, [selectedVendor, debouncedQuery.value, page, limit, selectedFilters]);
	
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedQuery(search);
		}, 500);
		return () => {
			clearTimeout(handler);
		};
	}, [search.value]);

	useEffect(() => {
		dispatch(staticData.loadStaticData((data) => {
			setDropdownData(data);
		}));
	}, []);

	useEffect(() => {
    // Wait for dropdownData to be defined before executing
    if (!dropdownData) return;
		selectedFilters.length> 0 && setSelectedFilters([]);
    const segment = selectedVendor === 'aws' ? dropdownData.awsSegment : dropdownData.segment;
    setSegment(segment);
	}, [selectedVendor, dropdownData]);

	// Update filtered data when members change
	useEffect(() => {
		updateData(members);
	}, [members]);

	if(loading || members == null) {
		return (
			<PageBase title="Contacts" hideRefresh>
				<div className="contacts-header">
					<div className="contacts-search-box">
						<ToggleButton options={['aws', 'ms']} value={selectedVendor} onToggle={() => setSelectedVendor(selectedVendor === 'aws' ? 'ms' : 'aws')} />
					</div>
				</div>
			</PageBase>
		)
	}

	const updateFilter = (value) => {
		setPage(1);
		setSearch({
			"key": "contact_name",
			"value": value.toLowerCase(),
			"operator": {
				"key": "contains",
			}
		});
	};

	// const updateSort = (sortColumn) => {
	// 	if(sortColumn === sortBy) {
	// 		setSortOrder(sortOrder === "asc" ? "desc" : "asc");
	// 	}
	// 	else {
	// 		setSortBy(sortColumn);
	// 		setSortOrder("asc");
	// 	}
	// };

  const onAddFilter = (filter) => {
		setPage(1);
		const index = selectedFilters.findIndex(f => f.name === filter.name);

		if(index < 0) {
			setSelectedFilters([...selectedFilters, filter]);
		}
		else {
			const updated = [...selectedFilters];
			updated[index] = filter;
			setSelectedFilters(updated);
		}
  };

	const onRemoveFilter = (filterToRemove) => {
		setPage(1);
		setSelectedFilters(selectedFilters.filter(f => f.key !== filterToRemove.key));
	};

	const clearFilters = () => {
		setPage(1);
		clearPersistentFilters();
	};

const availableFilters = [
		{ label: 'Name', key: 'contact_name', type: 'text' },
		{ label: 'Email', key: 'email', type: 'text' },
		{ label: 'Title', key: 'title', type: 'text' },
		{ label: 'Segment', key: 'segment', type: 'list', values: segment },
		{ label: 'Account Type', key: 'account_type', type: 'list',values: dropdownData?.accountType },
		{ label: 'Reports To', key: 'reports_to', type: 'text' }
];

		const renderSelectedContact = (row, isHeader = false, column = null) => {
	const isAllSelected = selectedContacts.length > 0 && filteredData.every(d =>
		selectedContacts.some(c => c.contact_id === d.contact_id)
	);

	const handleCheckboxChange = (e) => {
		e.stopPropagation();
		if (isHeader) {
			if (isAllSelected) {
				setSelectedContacts([]);
			} else {
				const contactsToSelect = filteredData.map(row => ({
					contact_id: row.contact_id,
					account_id: null,
					account_name: null
				}));
				setSelectedContacts(contactsToSelect);
			}
		} else {
			const contact = { contact_id: row.contact_id, account_id: null, account_name: null };
			setSelectedContacts(prev => 
				prev.some(c => c.contact_id === row.contact_id)
					? prev.filter(c => c.contact_id !== row.contact_id)
					: [...prev, contact]
			);
		}
	};

	let displayValue = '';
	if (column) {
		if (isHeader) {
			displayValue = column.name;
		} else if (typeof column.selector === 'function') {
			displayValue = column.selector(row);
		} else {
			displayValue = row[column.id] || '';
		}
	}

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
			<div onClick={e => e.stopPropagation()}>
				<input 
					type="checkbox"
					checked={isHeader ? isAllSelected : selectedContacts.some(c => c.contact_id === row.contact_id)}
					onChange={handleCheckboxChange}
				/>
			</div>
			<span>{displayValue}</span>
		</div>
	);
		};

		if (fieldsToUse.length > 0) {
			const firstCol = fieldsToUse[0];
			fieldsToUse[0].cell = row => renderSelectedContact(row, false, firstCol);
			fieldsToUse[0].header = () => renderSelectedContact(null, true, firstCol);
		}

	const onAddToCampaign = () => {
		if(selectedContacts.length === 0) {
			Toaster.showError("Please select a contact to add to campaign");
			return;
		}
		setShowPickCampaign(true);
	}

	const onSelectContactCampaign = (campaign) => {
		setSelectedCampaignId(campaign.value);
	};

	const resetFields = () => {
		setFile(null);

		if(hiddenFileInput.current) {
			hiddenFileInput.current.value = "";
		}
	};

	const onUpload = async () => {
		setLoading(true);
		dispatch(contactActions.uploadContacts(file, selectedVendor, contactsUploaded));
	};

	const contactsUploaded = (result) => {
		setLoading(false);
		console.log(result);
		resetFields();
		Toaster.showSuccess("Contacts uploaded!");
	};

	const onFileClick = () => {
		resetFields();
		hiddenFileInput.current?.click();
	};

	const onRowClick = async (row, index) => {
	
			const report ={field: `contact_name`, value: row.contact_name, relatedTable: 'accounts'};

			navigate(`/contact/${selectedVendor}/${row.contact_id}`, { 
					state: { 
							row, 
							title: "Contact",
							headerLinkTexts:"All contacts", 
							headerLinkTarget: ROUTES.CONTACTS, 
							titleName: row.contact_name,
							report
					} 
			});
		};

	const onFileChange = event => {
		const fileUploaded = event.target.files[0];
		if(!fileUploaded) {
			return;
		}

		setFile(fileUploaded);
	};

	const handlePageChange = (newPage) => {
		setPage(newPage);
	};

	return (
		<PageBase title="Contacts"
		          hideRefresh
		>

			<PopupWin
				closeOnEscape={false}
				closeOnDocumentClick={false}
				visible={showPickCampaign}
				onClose={() => setShowPickCampaign(false)}
				title="Select Campaign"
				contentStyle={{width: '100%', height: '90%'}}
				popupStyle={{width: '700px', height: '500px', overflow: 'none'}}
				footer={selectCampaignFooter}>
				<div style={{display: 'flex', flexDirection: 'column', padding: '20px'}}>
					<div style={{height: '320px'}}>
						<SelectCampaign selectedVendor={selectedVendor} onSelectContactCampaign={onSelectContactCampaign} />
					</div>
				</div>
			</PopupWin>

			<div className="contacts-header">
				<div className="contacts-search-box">
					<ToggleButton options={['aws', 'ms']} value={selectedVendor} onToggle={() => setSelectedVendor(selectedVendor === 'aws' ? 'ms' : 'aws')} />
					<img alt="" src={searchIcon} style={{padding: '0 10px', marginLeft: '20px'}} />
					<input className="contacts-search-input" type="text" value={search?.value} onChange={e => updateFilter(e.target.value)} placeholder="Search Contacts..." />
				</div>
				<div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
					<Button type="blue" disabled={selectedContacts.length===0} width={160}  onClick={()=>onAddToCampaign()}>Add to campaign</Button>
					<Filters
						availableFilters={availableFilters}
						selectedFilters={selectedFilters.filter(filter => filter.name !== 'search')}
						onAddFilter={onAddFilter}
						onRemoveFilter={onRemoveFilter}
						clearFilters={clearFilters}
						/>
				</div>
				
				<div style={{ flexGrow: 1, paddingRight: 20, justifyContent: 'flex-end', display: 'flex', alignItems: 'center' }}>
					<ListManager
						entityType={entityType}
						displayFields={getDisplayFields()}
						defaultFields={getDisplayFields(true).map(f=>f.field)}
						onColumnsChange={setListColumns}
					/>
				</div>
			</div>

			{selectedFilters.length > 0 && (
				<div>
					<p style={{ color: '#062229', fontWeight: 700, fontSize: 14 }}>Found {total || 0} Contacts</p>
				</div>
			)}

			<Datatable 
				gridHeight="calc(100vh - 185px)"
				columns={fieldsToUse}
				data={filteredData}
				key={filterResetKey}
				//onSort={updateSort}
				sortBy={sortBy}
				sortOrder={sortOrder}
				onRowClick={onRowClick}
				filters={filters}
				onFilterChange={handleFilterChange}
				filterOrder={filterOrder}
				uniqueValuesByColumn={uniqueValuesByColumn}
				allData={members}
			/>

			<Pagination
				entityLabel='Contacts'
				showPageSizeSelector={false}
				currentPage={page}
				totalPages={totalPages}
				totalItems={total}
				pageSize={limit}
				onPageChange={handlePageChange}
			/>
		</PageBase> 
	)
};

export default Contacts;
